import HttpWrapper from '@/utils/http/httpWrapper'
import { httpPostBuilder } from '@/utils/http/httpBuilderPresets'
import { store } from '@/store'
import toastr from 'toastr'
import ShipbobAppSettings from '../../appSettings/appSetting'

const SHIPBOB_API = ShipbobAppSettings.FulfillmentCustomizationApiUrl
const ATTACHMENTS_API = ShipbobAppSettings.AppSettings.AttachmentEndpoint + '/api/attachment'

/**
 * Contains the API Requests for customizing and
 * enabling / disabling gift notes.
 */
class GiftNoteServiceInternal {
  /**
   * A function that makes an object that
   * @returns {Object} returns an object that contains the necessary strings
   * for making the gift notes customization api requests.
   */
  urls () {
    return {
      setCustomerPreference: SHIPBOB_API + '/setPreference',
      setCustomerPreferenceValue: SHIPBOB_API + '/giftnote/uploadlogo',
      uploadAttachment: ATTACHMENTS_API + '?domainType=8&fileType={fileType}&blobKey=211bd3eb-b554-40b9-9777-fe4390aea7bc&fileName={fileName}',
      customizeGiftNoteUrl: SHIPBOB_API + '',
      getAttachment: SHIPBOB_API + '/giftnote/templateData',
      getRecentGiftNotes: SHIPBOB_API + '/giftnote/recent'

    }
  }

  /**
   * Updates the customers preference for gift notes in
   * [CustomerPreferenceTable] and [CustomerPreferenceTypeId] = 228
   * @param {guid} id
   * @param {boolean} setting
   * @returns {Promise} returns the promise response from the post request
   */
  async setCustomerPreference (setting, value) {
    const request = {
      Url: `${
        this.urls().setCustomerPreference
      }?setting=${setting}&value=${value}`
    }
    const res = await HttpWrapper.Post(request, () => {
      toastr.success('Customer preference updated.')
    }, this.handlePreferenceUpdateError, true)
    return res
  }

  async setCustomerPreferenceValue (id, value) {
    const request = {
      Url: `${
        this.urls().setCustomerPreferenceValue
      }`,
      Data: {
        LogoId: value,
        UserId: id
      }
    }
    const res = await HttpWrapper.Post(request, () => {
      toastr.success('Gift message logo has been updated.')
    }, this.handleUpdateError, true)
    return res
  }

  handleUpdateError = (res) => {
    toastr['error']('Error occured while updating logo.')
  }

  handlePreferenceUpdateError = (res) => {
    toastr['error']('Unable update customer preference.')
  }

  spitOutError () {
    toastr['error']('There has been and error during upload. Please verify your file is under 30mb and is in .png, .jpg, or .jpeg formats.')
  }

  async getGiftNoteTemplate () {
    const request = {
      Url: `${
        this.urls().getAttachment
      }`
    }
    return await HttpWrapper.Get(request)
  }

  /**
   * Gets 3 gift notes within the past month tied to this user
   * @returns {List<Object>} A list of objects containing gift notes and order id's
   */
  async getRecentGiftNotes () {
    const request = {
      Url: `${
        this.urls().getRecentGiftNotes
      }`
    }
    return await HttpWrapper.Get(request)
  }

  /**
   * Send a post request to update the stored information about
   * a gift note and it's preview.
   * @param {string} title the title of the gift note template
   * @param {guid} imageId the id of the image that is going to be on the gift note
   */
  async customizeGiftNote (title, imageId) {}

  /**
   * Upload the image to the attachment api so that it can be stored
   * for later use
   * @param {name{string}, filyType{string}, attachment{file}} param0 - A deserialized object that
   * contains the name filetype and attachment of the file to upload
   * @returns {guid} the ID of the file that was uploaded
   */
  async uploadImageAttachment ({ name, fileType, attachment }) {
    const data = new FormData()
    data.append('FileToUpload', attachment)
    const response = await httpPostBuilder()
      .withUrl(
        this.urls()
          .uploadAttachment.replace(/{fileName}/, name)
          .replace(/{fileType}/, fileType)
      )
      .withHeaders({ 'Content-Type': 'multipart/form-data' })
      .withBody(data)
      .withFailedSideEffect(() => {
        this.spitOutError()
      })
      .send()

    var lastSlash = response.AttachmentUri.lastIndexOf('/')
    let imageLocationId = response.AttachmentUri.substring(lastSlash + 1)
    const user = store.getters['user/getUser']
    const id = user.impersonatedUserId || user.id
    await GiftNotesService.setCustomerPreferenceValue(id, imageLocationId)
    return response
  }
}

export const GiftNotesService = new GiftNoteServiceInternal()
